<template>
  <v-app>
    <notification />

    <router-view />
  </v-app>
</template>

<script>
import Notification from '@/components/layout/Notification';

export default {
  components: { Notification }
};
</script>

<style>
.float-right {
  float: right;
}

.float-left {
  float: left;
}
</style>
